import React, { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { GiftDecisionModalComponent } from './types';
import Modal from 'components/base/Modal';

import { useDeference } from 'hooks/useArticles/useDeference';
import { useDeathLocation } from 'hooks/useDeathLocation';
import { Gift } from 'models/Gift';
import { showErrorToast } from 'utils/toasts';

export const GiftDecisionModal: FC<GiftDecisionModalComponent> = ({
  show, onCancel, onSuccess, recordId, city, location,
}) => {
  const { t } = useTranslation();
  const { updateDeferenceStatus } = useDeference();
  const { getDeathLocationByCode } = useDeathLocation(
    city,
  );

  const updateStatus = useCallback(
    (gift: Gift) => {
      updateDeferenceStatus(recordId, gift)
        .then((r) => {
          onSuccess(gift);
          return r;
        })
        .catch((e) => {
          showErrorToast(t(e.message));
        });
    },
    [onSuccess, recordId, t, updateDeferenceStatus],
  );

  return (
    <Modal
      buttons={[
        {
          id: 'yes',
          onClick: () => onSuccess(Gift.YES),
          text: t('record.gift.yes'),
        },
        {
          id: 'no',
          onClick: () => updateStatus(Gift.NO),
          text: t('record.gift.no'),
        },
        {
          id: 'later',
          onClick: () => updateStatus(Gift.LATER),
          text: t('record.gift.later'),
        },
      ]}
      className="gift-decision-modal"
      closeOnFocusLost={false}
      show={show}
      showCancel={false}
      showXButton={false}
      title={t('record.gift.title')}
      onHide={onCancel}
    >
      <div>{t('record.gift.question', { location: getDeathLocationByCode(location)?.description || '' })}</div>
    </Modal>
  );
};
